import React, { useEffect, useState } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { Box, CircularProgress, Typography, Alert, Container } from '@mui/material';
import { useAuth } from '../contexts/AuthContext';

const AuthCallbackPage: React.FC = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const { login } = useAuth();
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const code = searchParams.get('code');

    if (!code) {
      navigate('/login', { replace: true });
      return;
    }

    const role = sessionStorage.getItem('oauth_role') || 'learner';

    login('google', code, role)
      .then(() => {
        sessionStorage.removeItem('oauth_role');
        navigate('/dashboard', { replace: true });
      })
      .catch(() => {
        setError('Authentication failed. Please go back and try again.');
      });
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  if (error) {
    return (
      <Container maxWidth="xs">
        <Box sx={{ mt: 10, textAlign: 'center' }}>
          <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>
          <Typography
            variant="body2"
            sx={{ cursor: 'pointer', color: 'primary.main' }}
            onClick={() => navigate('/login')}
          >
            Back to sign in
          </Typography>
        </Box>
      </Container>
    );
  }

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', mt: 15, gap: 2 }}>
      <CircularProgress />
      <Typography variant="body2" color="text.secondary">
        Completing sign in…
      </Typography>
    </Box>
  );
};

export default AuthCallbackPage;
